var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusThinBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16a1.5 1.5 0 01-1.5 1.5h-9.5V27a1.5 1.5 0 11-3 0v-9.5H5a1.5 1.5 0 110-3h9.5V5a1.5 1.5 0 113 0v9.5H27a1.5 1.5 0 011.5 1.5z"
  })));
}
export default SvgPlusThinBold;